import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach a Cloudflare Turnstile token (set by the Turnstile widget) to protected form
// submits. Harmless when CAPTCHA is not configured — the header is simply absent.
api.interceptors.request.use((config) => {
  const t = typeof window !== "undefined" ? window.__turnstileToken : null;
  if (t) config.headers["cf-turnstile-response"] = t;
  return config;
});

export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";

// ---- Partner referral attribution ----
// Capture ?ref=CODE from the landing URL and persist it, so any lead or purchase
// this visitor later makes is credited to the referring partner.
export const getRef = () => {
  try { return localStorage.getItem("sawd_ref") || ""; } catch { return ""; }
};

if (typeof window !== "undefined") {
  try {
    const r = new URLSearchParams(window.location.search).get("ref");
    if (r && r.trim()) localStorage.setItem("sawd_ref", r.trim().toUpperCase().slice(0, 40));
  } catch (e) { /* ignore */ }
}

// Endpoints where a captured referral code should ride along in the POST body.
const REF_ENDPOINTS = ["/growth/report", "/seo-tool/unlock", "/checkout/session", "/templates/checkout", "/accelerator/subscribe"];
api.interceptors.request.use((config) => {
  if ((config.method || "").toLowerCase() === "post") {
    const url = config.url || "";
    if (REF_ENDPOINTS.some((e) => url.endsWith(e)) && config.data && typeof config.data === "object" && !config.data.ref) {
      const r = getRef();
      if (r) config.data = { ...config.data, ref: r };
    }
  }
  return config;
});

export const CALENDAR_LINK =
  "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0c-Yl8hEYOEbklOuIqbOc5cDryyYmxLH2DkAetWzRVjgZjLEaZwRZrEu9DMnFFspGwV1VaCxkR";

export const CONTACT = {
  phone: "+1 210-239-7606",
  phoneHref: "tel:+12102397606",
  email: "sales@sanantonioswebdesign.com",
  youtube: "https://youtube.com/@sanantoniowebdesignservice",
  twitter: "https://x.com/SanAntoniosWeb1",
  pinterest: "https://pin.it/4KPZ5T6BI",
  facebook: "https://www.facebook.com/Sanantonioswebdesign",
  facebookReviews: "https://www.facebook.com/Sanantonioswebdesign/reviews/?id=100063540162265&sk=reviews",
  instagram: "https://www.instagram.com/sanantonios_web_design/",
};
